import React from 'react';
import PropTypes from 'prop-types';
import AddressHeading from './AddressHeading';
import { useServiceablitityData } from '../../../hooks/order';
import { useTranslation } from 'react-i18next';

const InternetResultHeading = ({
  fixedWireless,
  fixedWirelessProducts,
  plans,
  isATTVendor,
  isTMOVendor,
  isBusinessAddress,
  getAggregatedAddress,
  normalizedAddress,
  onResetAddress,
  currentTfn,
  isSinglePageCheckout = false,
}) => {
  const { t } = useTranslation();
  const { isExistingCustomer } = useServiceablitityData();
  let title = '';
  if (isExistingCustomer && fixedWireless && fixedWirelessProducts?.length === 0) {
    title = t('products.titleAlreadyConnected');
  } else if (isExistingCustomer && fixedWireless && fixedWirelessProducts?.length > 0 && isATTVendor(fixedWireless.vendor)) {
    title = t('products.titleAlreadyConnected');
  } else if (!isExistingCustomer && fixedWireless && fixedWirelessProducts?.length > 0 && isATTVendor(fixedWireless.vendor)) {
    title = t('products.title5GAvailable');
  } else if (fixedWireless && fixedWirelessProducts?.length > 0 && isTMOVendor(fixedWireless.vendor)) {
    title = t('products.titleHighSpeedAvailable');
  } else if (!isExistingCustomer && isBusinessAddress) {
    title = t('products.titleBusinessAvailable');
  } else if (!isExistingCustomer) {
    title = t('products.titleEarthlinkAvailable');
  } else {
    title =
      fixedWirelessProducts?.length > 0 && plans.length > 0
        ? t('products.titleFiberAvailable')
        : fixedWirelessProducts?.length > 0 && plans.length === 0
          ? t('products.titleHooray')
          : t('products.titleFiberAvailable');
  }

  return (
    <div className={`internet-result-heading internetOuterClass${isSinglePageCheckout ? ' internet-result-heading_spc' : ''}`}>
      <div className={`elink-container${isSinglePageCheckout ? ' elink-container_spc' : ''}`}>
        <AddressHeading
          title={title}
          address={getAggregatedAddress(normalizedAddress)}
          onResetAddress={onResetAddress}
          isExistingCustomer={isExistingCustomer}
          currentTfn={currentTfn}
          isSinglePageCheckout={isSinglePageCheckout}
        />
      </div>
    </div>
  );
};

InternetResultHeading.propTypes = {
  fixedWireless: PropTypes.object,
  fixedWirelessProducts: PropTypes.array,
  plans: PropTypes.array,
  isATTVendor: PropTypes.func.isRequired,
  isTMOVendor: PropTypes.func.isRequired,
  isBusinessAddress: PropTypes.bool,
  getAggregatedAddress: PropTypes.func.isRequired,
  normalizedAddress: PropTypes.object.isRequired,
  onResetAddress: PropTypes.func.isRequired,
  currentTfn: PropTypes.string,
  isSinglePageCheckout: PropTypes.bool,
};

export default InternetResultHeading;
